<template>
	<div class="c-body">
		<div class="c-home-hero">
			<img src="/assets/img/svg/hero-text.svg" alt="" class="c-home-hero__text" alt="サッと使えるWebの道具箱。">
		</div>
		<div class="c-body__inner">
			<div class="e-section">
				<div class="c-home-applist">
					<ul class="c-home-applist__list">
						<li class="c-home-applist__item">
							<a href="/mkpasswd">
								<img src="/assets/img/svg/appicon/mkpasswd.svg" alt="">
							</a>
						</li>
						<li class="c-home-applist__item">
							<a href="/gridcalc">
								<img src="/assets/img/svg/appicon/gridcalc.svg" alt="">
							</a>
						</li>
						<li class="c-home-applist__item">
							<a href="/ratiocalc">
								<img src="/assets/img/svg/appicon/ratiocalc.svg" alt="">
							</a>
						</li>
						<li class="c-home-applist__item">
							<a href="/datauri">
								<img src="/assets/img/svg/appicon/datauri.svg" alt="">
							</a>
						</li>
						<li class="c-home-applist__item">
							<a href="/asciitree">
								<img src="/assets/img/svg/appicon/asciitree.svg" alt="">
							</a>
						</li>
						<li class="c-home-applist__item">
							<a href="/multimentions">
								<img src="/assets/img/svg/appicon/multimentions.svg" alt="">
							</a>
						</li>
						<li class="c-home-applist__item">
							<a href="/zen2han">
								<img src="/assets/img/svg/appicon/zen2han.svg" alt="">
							</a>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

import mCommon from "../mixins/common";

export default {
	mixins: [
		mCommon
	],
	data(){
		return {
		}
	}
}
	
</script>


// WEBPACK FOOTER //
// home.vue?b73e85da